<template>
  <div class="scroll">
    <vue-seamless-scroll
      :data="Data"
      class="seamless-warp"
      :class-option="classOption"
    >
      <ul class="list" v-if="type=='0'">
        <li style="cursor: pointer;" v-for="(item, index) in Data" :key="index" @click="toPathDetail(item.id)">
          <span :title="item.startDate">
            {{ item.startDate }}
          </span>
          <span :title="item.policyTheme">
            {{ item.policyTheme }}
          </span>
        </li>
      </ul>
      <ul class="list" v-else-if="type=='1'">
        <li style="cursor: pointer;" v-for="(item, index) in Data" :key="index" @click="toPathDetail(item.id)">
          <span :title="item.startDate">
            {{ item.startDate }}
          </span>
          <span :title="item.policyTheme">
            {{ item.policyTheme }}
          </span>
          <span :title="item.policyContent">
            {{ item.policyContent }}
          </span>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  props: {
    Data: {
      type: Array
    },
    type:{
      type:String,
      default:"0"
    }
  },
  data() {
    return {
      classOption: {
        step: 0.18, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods:{
    // 跳转至政策信息详情
    toPathDetail(id){
      if(id){
        window.localStorage.setItem('policyInformation_detail_id',id)
        this.$router.push('/policyInformation')
      }
    }
  },
  components: { //组件
    vueSeamlessScroll
  },

}
</script>

<style>
.seamless-warp {
  width: 100%;
  /* height: 17.9rem; */
  height: 11.8rem;

  overflow: hidden;
  /* box-shadow: inset 0px 0px 0.7762rem 0px #6888c2;
  -webkit-box-shadow: inset 0px 0px 0.7762rem 0px #6888c2;
  -moz-box-shadow: inset 0px 0px 0.7762rem 0px #6888c2; */
  border-top: none;
  /* box-sizing: border-box; */
}
.scroll {
  overflow: hidden;
}
.list,
.title {
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}
.title {
  background-color: #1a3763;
  color: #a1dee5;
  padding: .2083rem 0;
  font-size: 1rem;
}
li span {
  display: inline-block;
  width: 25%;
  /* text-align: center; */
}
.list > li > span {
  padding: .2083rem 0;
  color: #b4babf;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list .is_action span{
  color: red;
}
</style>